const categoryOptions = [
  { value: 'PROMOTIONAL', label: 'Promotional' },
  { value: 'SYSTEM_INFORMATION', label: 'System Information' },
  { value: 'FESTIVAL_MESSAGE', label: 'Festival Message' },
  { value: 'DAY_SPECIAL', label: 'Day Special' },
]

const groupOptions = [
  {
    value: 'PRODUCTS',
    label: 'Products',
    subGroupOptions: [
      { value: 'BRAND', label: 'Brand', seoUrl: '/products/brands' },
      { value: 'DETAILS', label: 'Detail', seoUrl: '/products' },
      {
        value: 'BRAND_WEEK',
        label: 'Brand Week',
        seoUrl: '/products/brand-week',
      },
      { value: 'SHOP', label: 'Shop', seoUrl: '/categories' },
      { value: 'HOT', label: 'Hot', seoUrl: '/products/hot-sale' },
      { value: 'FRESH', label: 'Fresh', seoUrl: '/products/fresh-sale' },
      { value: 'FLASH', label: 'Flash', seoUrl: '/flash-sale/products' },
      {
        value: 'CATEGORIES',
        label: 'Categories',
        seoUrl: '/products/categories',
      },
    ],
  },
  {
    value: 'BRANDS',
    label: 'Brands',
    subGroupOptions: [
      { value: 'FLASH', label: 'Flash', seoUrl: '/products/brands' },
      { value: 'NORMAL', label: 'Normal', seoUrl: '/brands' },
      { value: 'FEATURED', label: 'Featured', seoUrl: '/brands/featured' },
    ],
  },
  {
    value: 'VACCINATION',
    label: 'Vaccination',
    subGroupOptions: [],
  },
  {
    value: 'CAMPAIGNS',
    label: 'Campaign',
    seoUrl: '/brands',
  },
  {
    value: 'PRODUCT_CAMPAIGNS',
    label: 'Product Campaign',
    subGroupOptions: [
      { value: 'normal', label: 'Normal', seoUrl: '/product-campaigns' },
      { value: 'discount', label: 'Discount', seoUrl: '/product-campaigns' },
    ],
  },
  {
    value: 'PAGES',
    label: 'Pages',
  },
  {
    value: 'PREDICTIONS',
    label: 'Predictions',
  },
]

const typeOptions = [
  { value: 'push', label: 'Push' },
  { value: 'in_app', label: 'In App' },
  { value: 'both', label: 'Both' },
]

const notificationGroup = [
  { value: 'scheduled', label: 'Scheduled', icon: 'smartphone' },
  { value: 'bulk', label: 'Instant', icon: 'message' },
]

const notificationTypeOptions = [
  { value: 'app_notification', label: 'App', icon: 'smartphone' },
  { value: 'sms', label: 'Sms', icon: 'message' },
  // { value: 'EMAIL', label: 'Email', icon: 'mail' },
]

const bulkNotificationTypeOptions = [
  { value: 'sms', label: 'Sms', icon: 'message' },
  { value: 'in_app', label: 'In App', icon: 'message' },
  { value: 'push', label: 'Push', icon: 'message' },
]

const productListType = {
  cart: { value: 'cart', label: 'Cart' },
  wishlist: { value: 'wishlist', label: 'Wishlist' },
}

const scheduleFilters = [
  { value: 'ALL', label: 'All', type: 'schedule' },
  { value: 'RECURRING', label: 'Recurring', type: 'schedule' },
  { value: 'NON_RECURRING', label: 'Non Recurring', type: 'schedule' },
]

const statusFilters = [
  { value: 'ALL', label: 'Status: All', type: 'status' },
  { value: 'IN_PROGRESS', label: 'Status: In Progress', type: 'status' },
  { value: 'SENT', label: 'Status: Sent', type: 'status' },
  { value: 'FAILED', label: 'Status: Failed', type: 'status' },
]

const productType = ['Cart', "Wishlist"]

const  filterTypes = [
  { value: 'user', label: 'Users' },
  { value: 'cart', label: 'Cart' },
  { value: 'wishlist', label: 'Wishlist' },
  { value: 'number', label: 'Specific User(s)' },
]

const initialNotification = {
  type: 'app_notification',
  action: typeOptions[0].value,
  extras: {
    notification_group: '',
    sub_group: null,
    name: '',
    id: '',
  },
  filter_type: "user",
  mobile: [],
  title: '',
  message: '',
  image_url: '',
  filters: [],
  notification_type: '',
  users: [],
  scheduled_at: '',
  repeat_method: 'DAILY',
  schedule_type: 'RECURRING',
}

const initialAge = { fromAge: '', toAge: '' }

const userGroup = [
  {value: 'all', label: 'All'},
  {value: 'user_group', label: 'User Group'},
  {value: 'guest', label: 'Guest Users'}
]

const smsCharacterLimit = 480

export {
  scheduleFilters,
  statusFilters,
  categoryOptions,
  typeOptions,
  groupOptions,
  notificationTypeOptions,
  productListType,
  initialNotification,
  filterTypes,
  initialAge,
  productType,
  notificationGroup,
  bulkNotificationTypeOptions,
  userGroup,
  smsCharacterLimit
}
